import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import useTheme from "@mui/material/styles/useTheme";

import useSunoDialer from "../use-suno-dialer.hook";
import { WIDGET_BACKGROUND } from "../utils";
import ActionButtonsBlock from "./components/action-buttons-block.component";
import InfoBlock from "./components/info-block.component";
import TitleBlock from "./components/title-block.component";

const animation = {
  "@keyframes GradientBackground": {
    "0%": {
      background: `linear-gradient(180deg, ${WIDGET_BACKGROUND})`
    },

    "25%": {
      background: `linear-gradient(0deg, ${WIDGET_BACKGROUND})`
    },

    "50%": {
      background: `linear-gradient(180deg, ${WIDGET_BACKGROUND})`
    },
    "75%": {
      background: `linear-gradient(0deg, ${WIDGET_BACKGROUND})`
    },
    "100%": {
      background: `linear-gradient(180deg, ${WIDGET_BACKGROUND})`
    }
  }
};

export default function IncomingCallWidget() {
  const theme = useTheme();
  const {
    incomingCall,
    displaySettings: { showQueue },
    isExpanded,
    handleToggleExpand
  } = useSunoDialer();

  return (
    <Stack
      key={incomingCall?.id}
      className="animate__animated animate__slideInRight"
      sx={{
        minWidth: showQueue ? "447px" : undefined,
        background: `linear-gradient(180deg, ${WIDGET_BACKGROUND})`,
        borderRadius: "12px",
        boxSizing: "border-box",
        boxShadow: theme.shadows[3],
        animationName: "GradientBackground",
        animationDuration: "2.5s",
        animationIterationCount: "infinite",
        ...animation
      }}
    >
      <Stack maxWidth="80px" sx={{ position: "absolute", right: 2, top: 2 }}>
        <IconButton
          size="small"
          sx={{
            p: 0,
            transform: "scale(0.9)",
            background: "hsla(180, 1%, 15%, 0.3)",

            color: "white"
          }}
          onClick={(event) => {
            event.stopPropagation();
            handleToggleExpand();
          }}
        >
          {isExpanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </IconButton>
      </Stack>
      <TitleBlock />
      {isExpanded && <InfoBlock />}

      <ActionButtonsBlock />
    </Stack>
  );
}
